import pages from './pages/index'
import global from './global.json'
import tDesign from './tDesign.json'

export default {
  pages,
  global,
  tDesign,
}
